export const state = {
  // product: undefined,
  // products: []
  facture: {},
  factures: [],
  pagination: {
    size: 10,
  },
}
